import { isEqualEpsilon } from "./Commons";

declare global {
  interface Console {
    tablediff(
      neuerWert: any[],
      alterWert: any[],
      keyColumn?: string,
      equals?: (a: any, b: any) => boolean,
    ): void;
  }
}

export {};

const isEqual = (a, b) => (Number.isNaN(a) && Number.isNaN(b) ? true : isEqualEpsilon(a, b));

const addMark = "➕";
const delMark = "➖";
const diffMark = "🔼";

window.console.tablediff = function (
  neuerWert: any[],
  alterWert: any[],
  keyColumn?: string,
  equals = isEqual,
) {
  const newArr = Array.isArray(neuerWert) ? neuerWert : [];
  const oldArr = Array.isArray(alterWert) ? alterWert : [];

  // Falls keyColumn angegeben ist, werden die Arrays anhand dieses Keys verglichen.
  let combined: { newObj?: any; oldObj?: any }[] = [];
  if (keyColumn) {
    const oldMap = new Map(oldArr.map((obj) => [obj[keyColumn], obj]));
    const newMap = new Map(newArr.map((obj) => [obj[keyColumn], obj]));

    // Keys sammeln, die in beiden oder nur in einer der Arrays vorkommen
    const allKeys = new Set([...Array.from(oldMap.keys()), ...Array.from(newMap.keys())]);

    for (const k of allKeys) {
      combined.push({
        oldObj: oldMap.get(k),
        newObj: newMap.get(k),
      });
    }
  } else {
    // Fallback: Indexbasiert
    const rowCount = Math.max(newArr.length, oldArr.length);
    for (let i = 0; i < rowCount; i++) {
      combined.push({
        oldObj: oldArr[i],
        newObj: newArr[i],
      });
    }
  }

  // Alle Keys sammeln
  const allKeysSet = new Set<string>();
  if (keyColumn != null) {
    allKeysSet.add(keyColumn);
  }
  combined.forEach((row) => {
    if (row.newObj) Object.keys(row.newObj).forEach((k) => allKeysSet.add(k));
    if (row.oldObj) Object.keys(row.oldObj).forEach((k) => allKeysSet.add(k));
  });
  const keys = Array.from(allKeysSet);
  if (keyColumn == undefined) {
    keyColumn = keys[0];
  }

  const rowCount = combined.length;

  const rowHasDifference = new Array(rowCount).fill(false);
  const colHasDifference: Record<string, boolean> = {};
  keys.forEach((k) => (colHasDifference[k] = false));

  const table: Record<string, any>[] = [];
  for (let i = 0; i < rowCount; i++) {
    const { newObj, oldObj } = combined[i];
    let record: Record<string, any> = {};
    if (newObj == oldObj) {
      record = { ...newObj };
    } else if (newObj == null) {
      record = { ...oldObj };
      record[keyColumn] = `${delMark} ${record[keyColumn]}`;
    } else if (oldObj == null) {
      record = { ...newObj };
      record[keyColumn] = `${addMark} ${record[keyColumn]}`;
    } else {
      let change = false;
      for (const key of keys) {
        const newVal = newObj[key];
        const oldVal = oldObj[key];
        if (!equals(newVal, oldVal)) {
          change = true;
          record[key] = `${diffMark} ${newVal} (${oldVal})`;
          rowHasDifference[i] = true;
          colHasDifference[key] = true;
        } else {
          record[key] = newVal;
        }
      }
      if (change) {
        record[keyColumn] = `${diffMark} ${record[keyColumn]}`;
      }
    }
    table.push(record);
  }

  const resultTable = table.map((row) => {
    const resultRow = {};
    for (let key of keys) {
      const resultKey = colHasDifference[key] ? `${diffMark} ${key}` : key;
      resultRow[resultKey] = row[key];
    }
    return resultRow;
  });

  console.table(resultTable);
};
